import { ModuleTree } from "vuex";
import { GetMyPaymentsFalconRequest } from "@/interfaces/falcon/get-my-payments/get-my-payments-falcon-request";
import { GetMyPaymentsFalconResponse } from "@/interfaces/falcon/get-my-payments/get-my-payments-falcon-response";
import { GetMyPaymentsPaymentListItem } from "@/interfaces/falcon/get-my-payments/get-my-payments-payment-list-item";
import { FalconService } from "@/services/falcon.service";
import { RequestAlias } from "@/enums/request-alias.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 *
 */
export const FalconPaymentsModule: ModuleTree<unknown> = {
  falconPayments: {
    namespaced: true,
    state: {
      paymentsData: [],
      paymentsTotalCount: 0
    },
    actions: {
      /**
       * Fetches user payments
       * @param commit Vuex commit
       * @param request Request data
       */
      getPayments({ commit }, request: GetMyPaymentsFalconRequest) {
        FalconService.request<
          GetMyPaymentsFalconRequest,
          GetMyPaymentsFalconResponse
        >(RequestAlias.GetMyPayments, request).then(response => {
          const {
            paymentList,
            paymentsCount
          } = response.data.getMyPaymentsResponse;
          if (paymentList?.payment?.length) {
            commit("paymentsDataReceived", paymentList.payment);
            commit("paymentsTotalCountReceived", +paymentsCount);
          } else {
            commit("paymentsDataReceived", []);
            commit("paymentsTotalCountReceived", 0);
          }
        });
      }
    },
    mutations: {
      /**
       * Updates user paymentsData
       * @param state Vuex state
       * @param paymentsData Received paymentsData data
       */
      paymentsDataReceived(
        state,
        paymentsData: GetMyPaymentsPaymentListItem[]
      ) {
        state.paymentsData = paymentsData;
      },

      /**
       * Updates total payments count
       * @param state Vuex state
       * @param paymentsCount Received total payments count
       */
      paymentsTotalCountReceived(state, paymentsCount: number) {
        state.paymentsTotalCount = paymentsCount;
      }
    }
  }
};
